// ANGULAR DEPENDENCY
import { NgModule } from '@angular/core';

// NGRX
import { EffectsModule } from '@ngrx/effects';
import { ActionReducer, MetaReducer, StoreModule } from '@ngrx/store';
import { localStorageSync } from 'ngrx-store-localstorage';

// STORE REDUCER AND EFFECTS
import { EmployeeEffects	 } from './store/effects';
import * as fromEmployee from './store/reducer';

// SERVICES
import { EmployeeStoreService } from './employee-store.service';
import { EmployeeService } from './services/employee.service';


/**
 * Local storage sync function for sync store state keys with local storage
 */
export function localStorageSyncReducer(reducer: ActionReducer<any>): ActionReducer<any> {
  return localStorageSync({ keys: ['employee'], rehydrate: true })(reducer);
}

// add localstorage function in meta reducers
const metaReducers: Array<MetaReducer<any, any>> = [localStorageSyncReducer];

/**
 * This module is for configure Employee ngrx related stuff.
 *
 *   @author Vikas Thakkar <vikas.thakkar@saeculumsolutions.com>
 * Notes:-
 * Date: 4-24-2020 Employee store module created
 */
@NgModule({
  imports: [
    StoreModule.forFeature('Employee', fromEmployee.reducer, { metaReducers }),
    EffectsModule.forFeature([EmployeeEffects]),
  ],
  declarations: [],
  providers: [
    EmployeeService,
    EmployeeStoreService,
  ],
})
export class EmployeeStoreModule { }
